import {http, httpRaw} from "./http";

// Base
// const getBaseQueue = data => http({ methods:'get', url:`/pss/base/queue/list`, data})
// const postBaseQueueUpdate = data => http({ methods:'post', url:`/pss/base/queue/update`, data})
// const getBaseQueueDownload = data => http({ methods:'get', url:`/pss/base/queue/download`, data})
// const getBaseAppData = data => http({ methods:'get', url:`/pss/base/app/data`, data})

// Login
const postLogin = data => http({ methods:'post', url:`/auth/login`, data})
const getLoginCheck = data => http({ methods:'get', url:`/users/me`, data})
const postPasswordChange = data => http({ methods:'post', url:`/auth/change-password`, data})

// PSS
const postPSSInboundScan = data => http({ methods:'post', url:`/pss/inbound`, data})
const postPSSPyReturnInboundScan = data => http({ methods:'post', url:`/pss/py-return-inbound`, data})
const postPSSInboundReprint = data => http({ methods:'post', url:`/pss/inbound/reprint`, data})

const postExportNoEdiOrder = data => http({ methods:'post', url:`/exportNoEdiOrder`, data})
const postPSSOutboundScan = data => http({ methods:'post', url:`/pss/outbound`, data})

const postPSSReturnScan = data => http({ methods:'post', url:`/pss/return`, data})
const postPSSReturnClose = data => http({ methods:'post', url:`/pss/return/${data.returnBatchNumber}/close`, data})

const getPSSDashboardTodayInAndOut = data => http({ methods:'get', url:`/dashboard/scanning`, data})
const getPSSDashboardInOutList = data => http({ methods:'get', url:`/dashboard/in-out`, data})

const getPSSDashboardVolume = data => http({ methods:'get', url:`/dashboard/volume`, data})

const getConsolicationWaveList = data => http({ methods:'get', url:`consolidation/excel`, data})
const getConsolicationOrderList = data => http({ methods:'get', url:`consolidation/excel/${data.waveId}/orders`, data})
const getConsolicationRowList = data => http({ methods:'get', url:`consolidation/excel/${data.waveId}/rows`, data})
const postConsolicationScan = data => http({ methods:'post', url:`/consolidation/scan`, data})
const postConsolicationUploadExcel = data => http({ methods:'post', url:`/consolidation/excel`, data})
const getExportSortCodeCloseReport = data => http({ methods:'get', url:`/ExportSortCodeCloseReport`, data})

const getAutoSorterDashboard = data => httpRaw({ methods:'get', url:`/auto-sorter/dashboard`, data})
const getAutoSorterCurrentProfile = data => httpRaw({ methods:'get', url:`/auto-sorter/current-profile`, data})
const postAutoSorterCurrentProfile = data => httpRaw({ methods:'post', url:`/auto-sorter/current-profile`, data})
const getAutoSorterProfile = data => httpRaw({ methods:'get', url:`/auto-sorter/profiles/${data.id}`, data})
const patchAutoSorterProfile = (data, id) => httpRaw({ methods:'patch', url:`/auto-sorter/profiles/${id}`, data})
const deleteAutoSorterProfile = (data, id) => httpRaw({ methods:'delete', url:`/auto-sorter/profiles/${id}`, data})
const postAutoSorterProfile = data => httpRaw({ methods:'post', url:`/auto-sorter/profiles`, data})
const getAutoSorterProfiles = data => httpRaw({ methods:'get', url:`/auto-sorter/profiles`, data})
//DHL
const getPickupNoValidate = data => http({ methods:'get', url:`/pickupparcel/validate`, data})
const postCreatePickupNo = data => http({ methods:'post', url:`/pickupparcel/createTimesPickupNo`, data})
const getSortout = data => http({ methods:'get', url:`/pickupparcel/sortout`, data})
const postProcessStatus = data => http({ methods:'post', url:`/process/getProcessStatus`, data})
const postInboundValidate = data => http({ methods:'post', url:`/operation/validate`, data})
const getPickupDate = data => http({ methods:'get', url:`/operation/getTimesPickupNoStr`, data})
const PostHkInbound = data => http({ methods:'post', url:`/operation/inbound`, data})
const getMakerLabelUrl = data => http({ methods:'get', url:`/operation/makerLabelUrl`, data})
const getProblem = data => http({ methods:'get', url:`/operation/problem`, data})
const getCreateBox = data => http({ methods:'get', url:`/operation/createBox`, data})

const getLocationAll = data => http({ methods:'get', url:`/record-problem/getLocationAll`, data})
const getAllIssue = data => http({ methods:'post', url:`/record-problem/getAll-issue_parcel_bin`, data})
const getAllRedelivery = data => http({ methods:'post', url:`/record-problem/getAll-redelivery`, data})
const getDelIssue = data => http({ methods:'get', url:`/record-problem/del-issue_parcel_bin`, data})
const postSaveIssue = data => http({ methods:'post', url:`/record-problem/save-issue_parcel_bin`, data})
const postIssueDetail = data => http({ methods:'post', url:`/record-problem/get-issue_parcel_to_order`, data})
const postSaveIssueOrder = data => http({ methods:'post', url:`/record-problem/save-issue_parcel_to_order`, data})
const getDelIssueOrder = data => http({ methods:'get', url:`/record-problem/del-issue_parcel_to_order`, data})



export default {
  // getBaseQueue,
  // postBaseQueueUpdate,
  // getBaseQueueDownload,
  // getBaseAppData,

  postLogin,
  getLoginCheck,
  postPasswordChange,

  postPSSInboundScan: postPSSInboundScan,
  postPSSPyReturnInboundScan: postPSSPyReturnInboundScan,
  postPSSInboundReprint: postPSSInboundReprint,
  postExportNoEdiOrder:postExportNoEdiOrder,
  postPSSOutboundScan: postPSSOutboundScan,
  postPSSReturnScan: postPSSReturnScan,
  postPSSReturnClose: postPSSReturnClose,
  getPSSDashboardTodayInAndOut,
  getPSSDashboardInOutList,
  getPSSDashboardVolume,
  getConsolicationWaveList,
  getConsolicationOrderList,
  getConsolicationRowList,
  postConsolicationScan,
  postConsolicationUploadExcel,
  getExportSortCodeCloseReport,
  getAutoSorterDashboard,
  getAutoSorterCurrentProfile,
  postAutoSorterCurrentProfile,
  getAutoSorterProfile,
  patchAutoSorterProfile,
  deleteAutoSorterProfile,
  postAutoSorterProfile,
  getAutoSorterProfiles,

  getPickupNoValidate,
  postCreatePickupNo,
  getSortout,
  postProcessStatus,
  postInboundValidate,
  getPickupDate,
  PostHkInbound,
  getMakerLabelUrl,
  getProblem,
  getCreateBox,

  getLocationAll,
  getAllIssue,
  getAllRedelivery,
  getDelIssue,
  postSaveIssue,
  postIssueDetail,
  postSaveIssueOrder,
  getDelIssueOrder
}




// WEBPACK FOOTER //
// ./src/http/api.js